import { RootState } from '@app/store/types';

export const getLoadingStatus = (state: RootState) => state.requesterLink.status;

export const getError = (state: RootState) => state.requesterLink.error;
